export const FLOOR_5_DATA = [
  {
    floor: 5,
    building: 'A',
    apartmentNumber: 'A028',
    sceneName: 'scene_05krs_A028',
    sceneName_future: 'scene_05krs_A028_future',
    name: 'A028',
    label: 'A28',
    lookAt: '-20.34, 0, 120',
    face: 'north',

    relatedApartments: {
      2: 'A001',
      3: 'A010',
      4: 'A019',
      6: 'A037',
      7: 'A046',
      8: 'A055',
      9: 'A064',
      10: 'A073',
      11: 'A082',
      12: 'A091',
      13: 'A100',
      14: 'A109',
      15: 'A118',
      16: 'A126',
      17: 'talokerho2',
    },
  },
  {
    floor: 5,
    building: 'A',
    apartmentNumber: 'A029',
    sceneName: 'scene_05krs_A029',
    sceneName_future: 'scene_05krs_A029_future',
    name: 'A029',
    label: 'A29',
    lookAt: '-20.34, 0, 120',
    face: 'north',

    relatedApartments: {
      2: 'A002',
      3: 'A011',
      4: 'A020',
      6: 'A038',
      7: 'A047',
      8: 'A056',
      9: 'A065',
      10: 'A074',
      11: 'A083',
      12: 'A092',
      13: 'A101',
      14: 'A110',
      15: 'A119',
      16: 'A127',
      17: 'talokerho2',
    },
  },
  {
    floor: 5,
    building: 'A',
    apartmentNumber: 'A030',
    sceneName: 'scene_05krs_A030',
    sceneName_future: 'scene_05krs_A030_future',
    name: 'A030',
    label: 'A30',
    lookAt: '-20.34, 0, 120',
    face: 'north',

    relatedApartments: {
      2: 'A003',
      3: 'A012',
      4: 'A021',
      6: 'A039',
      7: 'A048',
      8: 'A057',
      9: 'A066',
      10: 'A075',
      11: 'A084',
      12: 'A093',
      13: 'A102',
      14: 'A111',
      15: 'A120',
      16: 'A128',
      17: 'talokerho2',
    },
  },
  {
    floor: 5,
    building: 'A',
    apartmentNumber: 'A031',
    sceneName: 'scene_05krs_A031',
    sceneName_future: 'scene_05krs_A031_future',
    name: 'A031',
    label: 'A31',
    lookAt: '-20.34, 0, 120',
    face: 'north',

    relatedApartments: {
      2: 'A004',
      3: 'A013',
      4: 'A022',
      6: 'A040',
      7: 'A049',
      8: 'A058',
      9: 'A067',
      10: 'A076',
      11: 'A085',
      12: 'A094',
      13: 'A103',
      14: 'A112',
      15: 'A121',
      16: 'A129',
      17: 'talokerho2',
    },
  },
  {
    floor: 5,
    building: 'A',
    apartmentNumber: 'A032',
    sceneName: 'scene_05krs_A032',
    sceneName_future: 'scene_05krs_A032_future',
    name: 'A032',
    label: 'A32',
    lookAt: '-20.34, 0, 120',
    face: 'north',

    relatedApartments: {
      2: 'A005',
      3: 'A014',
      4: 'A023',
      6: 'A041',
      7: 'A050',
      8: 'A059',
      9: 'A068',
      10: 'A077',
      11: 'A086',
      12: 'A095',
      13: 'A104',
      14: 'A113',
      15: 'A122',
      16: 'A130',
      17: 'talokerho2',
    },
  },
  {
    floor: 5,
    building: 'A',
    apartmentNumber: 'A033',
    sceneName: 'scene_05krs_A033',
    sceneName_future: 'scene_05krs_A033_future',
    name: 'A033',
    label: 'A33',
    lookAt: '-107, 0, 120',
    face: 'west',

    relatedApartments: {
      2: 'A006',
      3: 'A015',
      4: 'A024',
      6: 'A042',
      7: 'A051',
      8: 'A060',
      9: 'A069',
      10: 'A078',
      11: 'A087',
      12: 'A096',
      13: 'A105',
      14: 'A114',
      15: 'A123',
      16: 'A131',
      17: 'talokerho2',
    },
  },
  {
    floor: 5,
    building: 'A',
    apartmentNumber: 'A034',
    sceneName: 'scene_05krs_A034',
    sceneName_future: 'scene_05krs_A034_future',
    name: 'A034',
    label: 'A34',
    lookAt: '161.30, 0, 120',
    face: 'south',

    relatedApartments: {
      2: 'A007',
      3: 'A016',
      4: 'A025',
      6: 'A043',
      7: 'A052',
      8: 'A061',
      9: 'A070',
      10: 'A079',
      11: 'A088',
      12: 'A097',
      13: 'A106',
      14: 'A115',
      15: 'A123-1',
      16: 'A131-1',
      17: 'talokerho2',
    },
  },
  {
    floor: 5,
    building: 'A',
    apartmentNumber: 'A035',
    sceneName: 'scene_05krs_A035',
    sceneName_future: 'scene_05krs_A035_future',
    name: 'A035',
    label: 'A35',
    lookAt: '161.30, 0, 120',
    face: 'south',

    relatedApartments: {
      2: 'A008',
      3: 'A017',
      4: 'A026',
      6: 'A044',
      7: 'A053',
      8: 'A062',
      9: 'A071',
      10: 'A080',
      11: 'A089',
      12: 'A098',
      13: 'A107',
      14: 'A116',
      15: 'A124',
      16: 'A132',
      17: 'talokerho2',
    },
  },
  {
    floor: 5,
    building: 'A',
    apartmentNumber: 'A036',
    sceneName: 'scene_05krs_A036',
    sceneName_future: 'scene_05krs_A036_future',
    name: 'A036',
    label: 'A36',
    lookAt: '161.30, 0, 120',
    face: 'south',

    relatedApartments: {
      2: 'A009',
      3: 'A018',
      4: 'A027',
      6: 'A045',
      7: 'A054',
      8: 'A063',
      9: 'A072',
      10: 'A081',
      11: 'A090',
      12: 'A099',
      13: 'A108',
      14: 'A117',
      15: 'A125',
      16: 'A133',
      17: 'talokerho2',
    },
  },
]
